import { createSelector } from "@reduxjs/toolkit";

const getListReferralPartner = (state) => state.listReferralPartner;

const getPartnerInfo = (state) => state.partnerInfo;

const getIsGetReferralPartners = (state) => state.isGetReferralPartners;

const getIsUpdateReferralPartner = (state) => state.isUpdateReferralPartner;

const getIsRemoveReferralPartner = (state) => state.isRemoveReferralPartner;

const getIsGetStatusEmailSentW9Form = (state) =>
  state.isGetStatusEmailSentW9Form;

const getIsSendingEmailW9Form = (state) => state.isSendingEmailW9Form;

const getIsSentEmailW9Form = (state) => state.isSentEmailW9Form;

const getIsCheckingProvidedW9Form = (state) => state.isCheckingProvidedW9Form;

const getIsProvidedW9Formm = (state) => state.isProvidedW9Form;

const getTotal = (state) => state.total;

export const partnerInfoSelector = createSelector(
  [getPartnerInfo, getIsUpdateReferralPartner, getIsRemoveReferralPartner],
  (partnerInfo, isUpdateReferralPartner, isRemoveReferralPartner) => ({
    partnerInfo,
    isUpdateReferralPartner,
    isRemoveReferralPartner,
  })
);

export const referralPartnerSelector = createSelector(
  [
    getListReferralPartner,
    getIsGetReferralPartners,
    getTotal,
    getIsGetStatusEmailSentW9Form,
    getIsSendingEmailW9Form,
    getIsSentEmailW9Form,
    getIsCheckingProvidedW9Form,
    getIsProvidedW9Formm,
  ],
  (
    listReferralPartner,
    isGetReferralPartners,
    total,
    isGetStatusEmailSentW9Form,
    isSendingEmailW9Form,
    isSentEmailW9Form,
    isCheckingProvidedW9Form,
    isProvidedW9Form
  ) => ({
    listReferralPartner,
    isGetReferralPartners,
    total,
    isGetStatusEmailSentW9Form,
    isSendingEmailW9Form,
    isSentEmailW9Form,
    isCheckingProvidedW9Form,
    isProvidedW9Form,
  })
);
